import styled from 'styled-components';
import { Button } from '@veneer/core';
import { breakpoints } from '../../../constants/breakpoints';

export const Container = styled.div<{ isHpx: boolean; isRTL: boolean }>`
  display: flex;
  justify-content: ${({ isHpx }) => (isHpx ? 'flex-end' : 'space-between')};
  margin-top: ${({ isHpx }) => (isHpx ? 'auto' : '40px')};

  @media only screen and (max-width: ${breakpoints.bigtablet}) {
    flex-direction: column-reverse;
    align-items: center;
  }

  ${({ isHpx, isRTL }) =>
    isHpx &&
    `
      button:nth-of-type(1) {
        margin-left: ${isRTL ? '0' : '16px'};
        margin-right: ${isRTL ? '16px' : '0'};
      }

      @media only screen and (max-width: ${breakpoints.bigtablet}) {
        flex: 1;
        justify-content: flex-start;
        align-items: initial;
      }
  `}

  button:after {
    content: ' ';
    opacity: 0;
    position: absolute;
    inset: 0px;
  }
`;

export const FooterButton = styled(Button)<{ isHpx: boolean }>`
  @media only screen and (max-width: ${breakpoints.bigtablet}) {
    margin: ${({ isHpx }) => (isHpx ? '8px' : '14px')} 0 !important;
  }
`;

export const FooterButtonText = styled.span``;
